// extracted by mini-css-extract-plugin
export default {"likesWrapper":"_c084098f","noHover":"_c8cae403","navigationRefreshDropdownBodyWrapper":"_263557eb","navigationRefreshDropdown":"_5c759c68"};